var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForeigner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0635 5.29199V12.2207C14.0635 13.0117 13.8853 13.7051 13.5288 14.3008C13.1772 14.8965 12.667 15.353 11.998 15.6704C11.3291 15.9878 10.5381 16.1465 9.625 16.1465C8.24805 16.1465 7.17871 15.7949 6.41699 15.0918C5.65527 14.3838 5.27441 13.417 5.27441 12.1914V5.29199H7.5376V11.8472C7.5376 12.6724 7.70361 13.2778 8.03564 13.6636C8.36768 14.0493 8.91699 14.2422 9.68359 14.2422C10.4258 14.2422 10.9629 14.0493 11.2949 13.6636C11.6318 13.2729 11.8003 12.6626 11.8003 11.8325V5.29199H14.0635Z",
    fill: "#0D6BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeigner);
export default __webpack_public_path__ + "static/media/foreigner.44416161ce181ba0a6799bc49d6eb76e.svg";
export { ForwardRef as ReactComponent };